import React, { Component } from 'react';
import classNames from 'classnames';
import { withContext } from '../utils/StateProvider';
import { currentActorId } from '../utils/combat/combatEngine';

function Bar({ value, max, className }) {
  const pct = max > 0 ? Math.max(0, Math.min(100, (value / max) * 100)) : 0;
  return (
    <div className={classNames('stat-bar', className)}>
      <div className="stat-bar-fill" style={{ width: pct + '%' }} />
      <span className="stat-bar-label">{value} / {max}</span>
    </div>
  );
}

class PartyPortraits extends Component {
  render() {
    const { party, combat, effects, spellcasting, selectPortrait, characterSheet, openCharacterSheet,
            selectedItem, transferItem } = this.props.context;
    const activeId = currentActorId(combat);
    const spells = effects.filter((e) => e.type === 'spell');
    const casterSlots = spells.map((e) => e.partyIndex);
    const healedSlots = spells.filter((e) => e.allyIndex !== undefined).map((e) => e.allyIndex);
    // While picking a caster or a spell's target, portraits become clickable
    const picking = spellcasting && spellcasting.stage !== 'spell' ? spellcasting.stage : null;
    const canPick = (c) => (picking === 'caster' ? c.condition === 'good' && c.spells.length > 0 : c.condition !== 'dead');
    const sheetOpen = characterSheet !== null && !picking;
    // With an item in hand, a portrait click hands it to that character
    const handing = !picking && !!selectedItem;
    // A portrait picks a spell target, receives a handed item, or opens
    // that character's sheet
    const onPortraitClick = (index) => {
      if (picking) return () => selectPortrait(index);
      if (handing) return () => transferItem(index);
      return () => openCharacterSheet(index);
    };

    return (
      <div id="characters">
        {party.map((c, index) => (
          <div
            key={c.id}
            id={'character-' + (index + 1)}
            className={classNames('character', c.condition, {
              active: activeId === c.id || (spellcasting && spellcasting.casterId === c.id) || (sheetOpen && characterSheet === index),
              selectable: (picking && canPick(c)) || sheetOpen || handing,
              clickable: !picking && !handing && !sheetOpen
            })}
            style={{ backgroundImage: `url('${c.portrait}')` }}
            onClick={onPortraitClick(index)}
          >
            {(picking || handing) && <div className="select-number">{index + 1}</div>}
            {/* Re-keyed on every hit so the flash animation replays */}
            {c.hitCount > 0 && <div key={c.hitCount} className="hit-flash" />}
            {casterSlots.includes(index) && <div className="cast-glow" />}
            {healedSlots.includes(index) && <div className="heal-glow" />}
            {combat && combat.blocking[c.id] && <div className="character-badge">BLOCK</div>}
            {c.condition !== 'good' && <div className="character-condition">{c.condition.toUpperCase()}</div>}
            <div className="character-info">
              <div className="character-name">{c.name} <span>{c.className} {c.level}</span></div>
              <Bar value={c.hp} max={c.maxHp} className={c.hp / c.maxHp < 0.34 ? 'hp low' : 'hp'} />
              {c.maxSp > 0 && <Bar value={c.sp} max={c.maxSp} className="sp" />}
            </div>
          </div>
        ))}
      </div>
    );
  }
}

export default withContext(PartyPortraits);
